<app-header [category]="true"></app-header>
<div
  class="wrapper"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()"
  [infiniteScrollDisabled]="shimarStatus"
>
  <div class="container" *ngIf="homeData?.partnar_info?.id">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="partner-profile-detail">
          <div class="partner-profile">
            <div class="ratio-slider ratio-1-1">
              <img
                *ngIf="homeData?.partnar_info?.image"
                [src]="[homeData.partnar_info.image]"
              />
              <img
                *ngIf="!homeData?.partnar_info?.image"
                [src]="[app_constant.userNoImage]"
              />
            </div>
          </div>
          <div class="user-detail">
            <h1>{{ homeData?.partnar_info?.name }}</h1>
            <p
              class="text-secondary"
              *ngIf="homeData?.partnar_info?.total_content"
            >
              Videos <span class="dots"></span>
              {{ homeData?.partnar_info?.total_content }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section
    class="related-search upcoming"
    *ngIf="!shimarStatus && subcategory?.length > 0"
  >
    <div class="container">
      <div
        class="section-head head-pr-0 row justify-content-start pl-3"
        *ngIf="params.category"
      >
        <h2 class="mr-2">
          <a
            class="orange-link mr-1"
            title="Back"
            href="javascript:void(0)"
            (click)="location.back()"
            ><span class="mdi mdi-arrow-left"></span></a
          >{{
            subcategory[0].category[0].name
              ? subcategory[0].category[0].name
              : (apiParam.slug | removeDash)
          }}
        </h2>
        <span *ngIf="subcategory[0].category[0].sub_title" class="head-batch">{{
          subcategory[0].category[0].sub_title
        }}</span>
      </div>
      <div class="section-head head-pr-0 row" *ngIf="params.trading_courses">
        <h2 class="col-12">{{ gridConfig.grid_content.coursesTitle }}</h2>
      </div>
      <div class="section-head head-pr-0 row" *ngIf="params.top_rated">
        <h2 class="col-12">
          {{ gridConfig.grid_content.interviewsTitle | translate }}
        </h2>
      </div>
      <div class="section-head head-pr-0 row" *ngIf="params.audio_courses">
        <h2 class="col-12">
          {{ gridConfig.grid_content.trendingContentsTitle | translate }}
        </h2>
      </div>
      <div class="section-head head-pr-0 row" *ngIf="params.popular_list">
        <h2 class="col-12">
          {{ gridConfig.grid_content.popular }}
        </h2>
      </div>
      <div class="row custome-set">
        <div
          class="series-box"
          *ngFor="let watch of subcategory; let i = index"
        >
          <app-grid [data]="watch" [gridType]="'landscape'"></app-grid>
        </div>
      </div>
    </div>

    <div class="w-100" *ngIf="loadMore">
      <app-grid-simmer class="search-page"></app-grid-simmer>
    </div>
  </section>
  <div
    class="record-not-available"
    *ngIf="subcategory?.length === 0 && !shimarStatus"
  >
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </div>
  </div>

  <app-grid-simmer
    class="search-page list-simmer"
    *ngIf="shimarStatus"
  ></app-grid-simmer>
</div>
<app-footer></app-footer>

